export const SUPPORTED_LANGS = ["uk", "ru", "ro"];
export const DEFAULT_LANG = "uk";
